module.exports = __webpack_public_path__ + "img/rune-frost.725e113e.png";